<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-row>
          <v-col align="center">
            <h1 class="text_title_1">
              {{
                WEB_LANGUAGE == "th"
                  ? text.transliteration_search.th
                  : WEB_LANGUAGE == "en"
                  ? text.transliteration_search.en
                  : "-"
              }}
            </h1>
          </v-col>
        </v-row>
        <!-- <pre>search : {{ search }}</pre> -->
        <!-- <pre>search list : {{ search_list }}</pre> -->
        <!-- <pre>selected search : {{ search_object_selected }}</pre> -->
        <!-- <pre>get Detail of Word : {{ word_detail }}</pre> -->
        <v-row justify="center" align="center">
          <v-col :cols="mobile ? '12' : '11'" sm="7" md="6">
            <!-- v-mask="mask" -->
            <!-- <pre>{{ languageBtnName }}</pre> -->
            <v-combobox
              :search-input.sync="search"
              :items="search_list"
              :loading="search_loading"
              v-model="search_object_selected"
              item-text="alphabet"
              return-object
              name="Insert transliteration"
              :placeholder="
                WEB_LANGUAGE == 'th'
                  ? text.search_placeholder.th
                  : WEB_LANGUAGE == 'en'
                  ? text.search_placeholder.en
                  : '-'
              "
              id="search"
              single-line
              autofocus
              outlined
              background-color="#ffffff"
              append-icon
              clearable
              style="z-index: 1"
              @keydown.enter="searchRomanWordAPI('enter')"
            >
              <template v-slot:append>
                <v-btn
                  style="margin-top: -13px; margin-right: -5px"
                  height="48px"
                  dark
                  class="bg_btn_search elevation-0"
                  @click="searchRomanWordAPI('click')"
                  :disabled="search_btn_disable"
                >
                  <v-icon color="white">mdi-magnify</v-icon>
                </v-btn>
              </template>
              <template v-slot:prepend-inner>
                <v-menu
                  transition="slide-y-transition"
                  offset-y
                  bottom
                  :close-on-content-click="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      style="
                        margin-top: -16px;
                        margin-left: -12px;
                        margin-right: 20px;
                      "
                      height="55px"
                      color="grey lighten-3"
                      class="elevation-0"
                    >
                      <font class="text_title_5" v-if="languageBtn == 'all'">
                        {{
                          WEB_LANGUAGE == "th"
                            ? text.all_language.th
                            : WEB_LANGUAGE == "en"
                            ? text.all_language.en
                            : "-"
                        }}
                      </font>
                      <font class="text_title_5" v-else>
                        <span v-if="!mobile">
                          {{
                            WEB_LANGUAGE == "th"
                              ? languageBtnName.languageName
                              : WEB_LANGUAGE == "en"
                              ? languageBtnName.languageNameEn
                              : "-"
                          }}
                        </span>
                        <span v-else>
                          {{
                            WEB_LANGUAGE == "th"
                              ? languageBtnName.languageShortName
                              : WEB_LANGUAGE == "en"
                              ? languageBtnName.languageShortNameEn
                              : "-"
                          }}
                        </span>
                      </font>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card max-width="700px">
                    <v-card-title primary-title>
                      <h2>
                        {{
                          WEB_LANGUAGE == "th"
                            ? text.all_language_title.th
                            : WEB_LANGUAGE == "en"
                            ? text.all_language_title.en
                            : "-"
                        }}
                      </h2>
                    </v-card-title>
                    <v-card-text>
                      <v-chip
                        class="ma-2"
                        outlined
                        v-for="(language, index) in languageList"
                        :key="index"
                        @click="selectFilterLanguage(language)"
                        :color="
                          languageBtn == language.languageId ? 'primary' : ''
                        "
                      >
                        <v-avatar size="48" tile>
                          <v-img
                            width="48"
                            :src="
                              require('@/assets/flag/' +
                                language.languagePathImg)
                            "
                          ></v-img>
                        </v-avatar>
                        <font class="text_title_5 ml-3">
                          {{
                            WEB_LANGUAGE == "th"
                              ? language.languageName
                              : WEB_LANGUAGE == "en"
                              ? language.languageNameEn
                              : "-"
                          }}
                        </font>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </template>
              <template v-slot:item="{ item }">
                <!-- HTML that describe how select should render selected items -->
                <v-list-item two-line @click="search_object_selected = item">
                  <v-list-item-content class="py-0 my-0">
                    <v-list-item-title class="py-0 my-0">
                      <span class="text_title_3">{{ item.alphabet }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle class="py-0 my-0">
                      <font class="text_body_4">
                        (
                        {{
                          WEB_LANGUAGE == "th"
                            ? text.transcription.th
                            : WEB_LANGUAGE == "en"
                            ? text.transcription.en
                            : "-"
                        }}
                        {{ item.transcription }} )
                      </font>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
        <span v-show="show_list_mode == 'foundList'">
          <v-row class="text_title_2" align="center" justify="center">
            <v-col
              :cols="mobile ? '12' : '10'"
              sm="7"
              md="6"
              align="start"
              justify="center"
            >
              <v-divider></v-divider>
            </v-col>
          </v-row>
          <v-row class="text_title_2" align="center" justify="center">
            <v-col
              :cols="mobile ? '12' : '10'"
              sm="7"
              md="6"
              align="start"
              justify="center"
            >
              <v-card flat>
                <v-card-title primary-title>
                  <h1 v-if="!mobile">
                    {{
                      WEB_LANGUAGE == "th"
                        ? text.found_list.th
                        : WEB_LANGUAGE == "en"
                        ? text.found_list.en
                        : "-"
                    }}
                    “{{ search_found_message }}”
                    {{
                      WEB_LANGUAGE == "th"
                        ? text.found_nearby_word.th
                        : WEB_LANGUAGE == "en"
                        ? text.found_nearby_word.en
                        : "-"
                    }}
                    {{ search_all_result_list.length }}
                    {{
                      WEB_LANGUAGE == "th"
                        ? text.list_unit.th
                        : WEB_LANGUAGE == "en"
                        ? text.list_unit.en
                        : "-"
                    }}
                  </h1>
                  <h2 v-if="mobile">
                    {{
                      WEB_LANGUAGE == "th"
                        ? text.found_list.th
                        : WEB_LANGUAGE == "en"
                        ? text.found_list.en
                        : "-"
                    }}
                    “{{ search_found_message }}”
                    {{
                      WEB_LANGUAGE == "th"
                        ? text.found_nearby_word.th
                        : WEB_LANGUAGE == "en"
                        ? text.found_nearby_word.en
                        : "-"
                    }}
                    {{ search_all_result_list.length }}
                    {{
                      WEB_LANGUAGE == "th"
                        ? text.list_unit.th
                        : WEB_LANGUAGE == "en"
                        ? text.list_unit.en
                        : "-"
                    }}
                  </h2>
                </v-card-title>
              </v-card>
              <v-card outlined>
                <v-list>
                  <v-list-item-group v-model="item" color="primary">
                    <v-list-item
                      v-for="(item, index) in search_all_result_list"
                      :key="index"
                      @click="search_object_selected = item"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-magnify</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.alphabet"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </span>
        <span v-show="show_list_mode == 'default'">
          <!-- OLD LANGUAGE SELECTOR -->
          <!-- <v-row justify="center" align="center">
            <v-col cols="7" justify="center" align="start">
              <v-row>
                <v-col cols="2" justify="center" align="right">
                  <v-btn text class="text_title_2" @click="languageBtn = 'all'">
                    <font
                      :class="languageBtn == 'all'?'text_title_underline_5':'text_title_5'"
                      :color=" languageBtn == 'all'?'#0c57d2':''"
                    >{{WEB_LANGUAGE == 'th'?text.all_language.th:(WEB_LANGUAGE == 'en'?text.all_language.en:'-')}}</font>
                  </v-btn>
                </v-col>
                <v-col cols="10">
                  <v-btn
                    text
                    class="text_title_2"
                    v-for="(language,index) in languageList"
                    :key="index"
                    @click="languageBtn = language.languageId"
                  >
                    <font
                      :class="languageBtn == language.languageId?'text_title_underline_5':'text_title_5'"
                      :color=" languageBtn == language.languageId?'#0c57d2':''"
                    >{{language.languageName}}</font>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>-->
          <v-row justify="center" align="center" style="margin-top: 0px">
            <v-col align="center" cols="12">
              <v-img
                width="350px"
                :src="require('@/assets/imagePNG/search_bg_crop.png')"
              ></v-img>
            </v-col>
          </v-row>
        </span>
        <span v-show="show_list_mode == 'not found'">
          <v-row justify="center" align="center">
            <v-col align="center" cols="12">
              <v-img
                width="300px"
                :src="require('@/assets/imagePNG/search_not_found_crop.png')"
                style="z-index: 0"
              ></v-img>
              <h1>
                {{
                  WEB_LANGUAGE == "th"
                    ? text.word_not_found_title.th
                    : WEB_LANGUAGE == "en"
                    ? text.word_not_found_title.en
                    : "-"
                }}
                “{{ search_not_found_message }}”
              </h1>
              <h4>
                {{
                  WEB_LANGUAGE == "th"
                    ? text.word_not_found_sub_title.th
                    : WEB_LANGUAGE == "en"
                    ? text.word_not_found_sub_title.en
                    : "-"
                }}
              </h4>
            </v-col>
          </v-row>
          <v-row class="text_title_2" align="center" justify="center">
            <v-col cols="12" sm="10" md="7" align="center" justify="center">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="10" md="7" align="start" justify="center">
              <CardRequestWord
                ref="card_request_word_not_found"
              ></CardRequestWord>
            </v-col>
            <v-col cols="12" sm="10" md="7" align="start" justify="center">
              <CardFeedback></CardFeedback>
            </v-col>
          </v-row>
        </span>
        <span v-show="show_list_mode == 'foundWord'">
          <!-- <pre>{{word_detail}}</pre> -->
          <v-row class="text_title_2" align="center" justify="center">
            <v-col cols="12" sm="10" md="7" justify="center" align="start">
              {{
                WEB_LANGUAGE == "th"
                  ? text.search_result.th
                  : WEB_LANGUAGE == "en"
                  ? text.search_result.en
                  : "-"
              }}
            </v-col>

            <!-- OLD LANGUAGE SELECTOR -->
            <!-- <v-col cols="7" justify="center" align="start">
              <v-row>
                <v-col cols="2" justify="center" align="center">
                  <v-btn text class="text_title_2" @click="languageBtn = 'all'">
                    <font
                      :class="languageBtn == 'all'?'text_title_underline_5':'text_title_5'"
                      :color=" languageBtn == 'all'?'#0c57d2':''"
                    >{{WEB_LANGUAGE == 'th'?text.all_language.th:(WEB_LANGUAGE == 'en'?text.all_language.en:'-')}}</font>
                  </v-btn>
                </v-col>
                <v-col cols="10">
                  <v-btn
                    text
                    class="text_title_2"
                    v-for="(language,index) in languageList"
                    :key="index"
                    @click="languageBtn = language.languageId"
                  >
                    <font
                      :class="languageBtn == language.languageId?'text_title_underline_5':'text_title_5'"
                      :color=" languageBtn == language.languageId?'#0c57d2':''"
                    >{{language.languageName}}</font>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>-->
            <v-col cols="12" sm="10" md="7" align="center" justify="center">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" sm="10" md="7" align="start" justify="center">
              <CardWordDetail ref="card_word_detail"></CardWordDetail>
            </v-col>
            <v-col cols="12" sm="10" md="7" align="start" justify="center">
              <CardRequestWord ref="card_request_word_found"></CardRequestWord>
            </v-col>
            <v-col cols="12" sm="10" md="7" align="start" justify="center">
              <CardFeedback></CardFeedback>
            </v-col>
          </v-row>
        </span>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CardWordDetail from "./SearchHomePageComponents/CardWordDetail.vue";
import CardRequestWord from "./SearchHomePageComponents/CardRequestWord.vue";
import CardFeedback from "./SearchHomePageComponents/CardFeedback.vue";
import { bus } from "@/main";
import { text_searchHomePage } from "@/assets/javascript/dataLanguage.js";
import flag from "@/views/AppBehide/Settings/LanguageList.js";

export default {
  components: {
    CardWordDetail,
    CardRequestWord,
    CardFeedback,
  },
  data() {
    return {
      WEB_LANGUAGE: "th",
      text: null,
      header_token: {
        headers: {
          token: "token_inet_dev",
        },
      },
      // mask:
      //   "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA",
      // base data
      languageList: [],
      languageBtn: "all",
      languageBtnName: "ทุกภาษา",
      // search variable
      search: "",
      search_btn_disable: true,
      search_object_selected: null,

      search_list: [],
      search_all_result_list: [],
      show_list_mode: "default",

      // search options
      search_loading: false,
      search_setTimeout: null,
      search_const_delay: 500,

      word_detail: null,

      // message to show only
      search_not_found_message: "",
      search_found_message: "",

      item: 20,
    };
  },
  computed: {
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    search(value) {
      if (value ? value.trim() != "" : false) {
        this.search_btn_disable = true;
        clearTimeout(this.search_setTimeout);
        this.search_setTimeout = setTimeout(() => {
          this.search_loading = true;
          this.searchRomanWordAPI("no-action");
          this.search_btn_disable = false;
        }, this.search_const_delay);
      } else {
        this.search_btn_disable = true;
        clearTimeout(this.search_setTimeout);
        this.search_list = [];
        this.search_object_selected = null;
        this.search_loading = false;
      }
    },
    search_object_selected(value) {
      // console.log("search_object_selected : ");
      // console.log(value);
      if (value) {
        this.searchRomanWordAPI("item-click");
      }
    },
    languageBtn(value) {
      // console.log(value);
      if (value == "all") {
        this.$refs.card_word_detail.setLanguageBtn("all");
      } else {
        this.$refs.card_word_detail.setLanguageBtn(value);
      }
      this.searchRomanWordAPI("item-click");
    },
  },
  created() {
    this.text = text_searchHomePage;
    bus.$on("switchLanguage", (data) => {
      this.WEB_LANGUAGE = data;
    });
    this.getLanguage();
    this.getCategory();
  },
  beforeDestroy() {
    bus.$off("switchLanguage");
  },
  methods: {
    selectFilterLanguage(language) {
      if (this.languageBtn == language.languageId) {
        this.languageBtn = "all";
      } else {
        this.languageBtn = language.languageId;
        this.languageBtnName = language;
      }
    },
    getLanguage() {
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/masterdata/language",
          this.header_token
        )
        .then((response) => {
          // console.log(response.data);
          this.languageList = response.data;
          this.$refs.card_word_detail.getLanguage(response.data);
          this.$refs.card_request_word_not_found.getLanguage(response.data);
          this.$refs.card_request_word_found.getLanguage(response.data);
        })
        .catch((err) => {
          // console.log("api get categoty detail err");
        });
    },
    getCategory(data) {
      this.axios
        .get(
          process.env.VUE_APP_API + "api/v1/masterdata/category",
          this.header_token
        )
        .then((response) => {
          // console.log(response.data);
          this.$refs.card_word_detail.getCategory(response.data);
        })
        .catch((err) => {
          console.log("api get categoty detail err");
        });
      // this.categoryList = data;
    },
    getDetailWord(pointer, sub_language) {
      // console.log(this.$refs);
      let pointerId = pointer;
      let subLanguageId = sub_language;
      if (pointerId) {
        this.axios
          .get(
            process.env.VUE_APP_API +
              "api/v1/search/" +
              pointerId +
              "/" +
              subLanguageId,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);
            this.word_detail = response.data;
            this.search_object_selected = null;
            setTimeout(() => {
              this.$refs.card_word_detail.setWordDetail(this.word_detail);
            }, 100);
          })
          .catch((err) => {
            // console.log("api search detail word err!");
            this.word_detail = null;
          });
      } else {
        // console.log("pointer id is NULL");
        this.word_detail = null;
        this.search_object_selected = null;
      }
    },
    updateListUI() {
      if (
        this.search_object_selected
          ? this.search_object_selected.pointerId
          : false
      ) {
        // console.log("get word");
        this.show_list_mode = "foundWord";
        // console.log(this.search_object_selected);
        this.getDetailWord(
          this.search_object_selected.pointerId,
          this.search_object_selected.subLanguageId
        );
      } else {
        if (this.search_list.length > 0) {
          // console.log("getList");
          this.show_list_mode = "foundList";
          this.search_all_result_list = this.search_list;
          this.search_list = [];
          this.search_object_selected = null;
          this.search_found_message = this.search.trim();
          this.word_detail = null;
        } else {
          // console.log("get not found");
          this.show_list_mode = "not found";
          this.search_all_result_list = [];
          this.search_list = [];
          this.search_not_found_message = this.search.trim();
          this.word_detail = null;
          this.search_object_selected = null;
        }
      }
    },
    searchRomanWordAPI(act) {
      let action = act;
      // console.log(action);
      // console.log(this.search_object_selected);
      if (!this.search) {
        return;
      }
      if (this.search.trim() == "") {
        return;
      }
      if (this.search_object_selected) {
        this.updateListUI();
      } else {
        let data = {
          item: 20,
          word: this.search.trim(),
          languageId: this.languageBtn != "all" ? this.languageBtn : 0,
        };
        this.axios
          .post(
            process.env.VUE_APP_API + "api/v1/search",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);
            this.search_list = response.data;
            if (action == "enter" || action == "click") {
              this.search_object_selected = null;
              this.search_list.forEach((element) => {
                if (this.search.trim() == element.alphabet.trim()) {
                  // console.log("found in loop");
                  this.search_object_selected = element;
                }
              });
              this.updateListUI();
            }
            this.search_loading = false;
            this.search_btn_disable = false;
          })
          .catch((err) => {
            // console.log("api search Roman word err!");
            this.search_list = [];
            this.search_object_selected = null;
            this.search_loading = false;
            this.search_btn_disable = true;
          });
      }
    },
  },
};
</script>
